module.exports = __webpack_public_path__ + "media/img/frontend_application/venue/bring-your-own-stuff-icon-45eb34c1796e1b1ee68d5ead86fd194d.png";